import {Factor} from "./factor";

export class Condition {
  factors: Factor[];

  constructor() {
    this.factors = [];
  }
}
